






































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {structureStore} from "@/store/store";
import SeasonRow from "@/modules/perRoad/views/components/SeasonRow.vue";
import {UnitSystem} from "@/interfaces/units";
import {createStructureValidations} from "@/modules/structure/lib/validations";
import PrLayerEditor from "@/modules/perRoad/views/components/structure/PrLayerEditor.vue";
import StructureLayerEditor from "@/modules/structure/views/StructureLayerEditor.vue";
import InspectorThreeJS from "@/modules/perRoad/views/components/inspection/InspectorThreeJS.vue";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import {
  convertDeterministicLayersImperial,
  convertDeterministicLayersMetric
} from "@/modules/structure/lib/convertLayers";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import {combineWesleaConfigSet, setCurrentResponseConfig} from "@/modules/structure/lib/createWesleaConfig";

Component.registerHooks(["validations"]);

@Component({
  components: {
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
    InspectorThreeJS,
    StructureLayerEditor,
    PrLayerEditor,
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PavementStructureResponseLocations extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;


  plotKey = 0;

  get scenario() {
    return structureStore.currentScenario;
  }

  get scenarioImperial() {
    return structureStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get simulatedLayers() {
    this.plotKey += 1;
    console.log("creating sim layers");
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return convertDeterministicLayersImperial(this.scenario.structureLayers);
    } else {
      return convertDeterministicLayersMetric(this.scenario.structureLayers);
    }
  }

  get combinedWesleaConfig() {
    if (this.scenario.wesleaConfigs) {
      return combineWesleaConfigSet(this.scenario.wesleaConfigs);
    }
  }

  createResponseGrid() {
    this.scenario.responsePattern = "grid";
    this.scenario.wesleaConfigs = setCurrentResponseConfig(this.scenario);
    this.incrementPlotKey();
  }

  createResponseLines() {
    this.scenario.responsePattern = "line";
    this.scenario.wesleaConfigs = setCurrentResponseConfig(this.scenario);
    this.incrementPlotKey();
  }

  incrementPlotKey() {
    this.plotKey += 1;
  }

  sync() {
    structureStore.setCurrentScenario(this.scenario);
    console.log(this.scenario.loads);
    this.incrementPlotKey();
  }

  save() {
    this.sync();
    structureStore.saveCurrentScenario();
  }

  validations() {
    return createStructureValidations(this.scenarioImperial, this.page);
  }

  mounted() {
    this.plotKey +=1;
  }
}

